import { createSelector } from "@reduxjs/toolkit";
import type { AppState } from "@redux/app-state";
import type { StudentPendingActionsVM } from "@shared-kernel/application/ports/student/student-repository";

const EMPTY_PENDING_ACTIONS: StudentPendingActionsVM = {
  hasActions: false,
  attendanceSheets: { pendingCount: 0 },
  surveys: { pendingCount: 0 },
  objectives: { pendingCount: 0 },
};

export const selectStudentPendingActions = createSelector(
  [(state: AppState) => state.student.pendingActionsRetrieval],
  ({ data, fetching }) => {
    if (fetching === "success" && data) {
      return data;
    }
    return EMPTY_PENDING_ACTIONS;
  },
);
